import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=7e543141"
import script from "./PackageItem.vue?vue&type=script&lang=js"
export * from "./PackageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports